const INGREDIENTS_INITIAL_STATE = {
  isLoading: false,
  error: undefined,
  data: undefined,
}

export default INGREDIENTS_INITIAL_STATE
